import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import AssistantWidget from './components/AssistantWidget';
import HomePage from './pages/HomePage';
import WebsitesPage from './pages/WebsitesPage';
import CheckoutResultPage from './pages/CheckoutResultPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

function App() {
  return (
    <div className="app">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects/websites" element={<WebsitesPage />} />
          <Route path="/projects/websites/result" element={<CheckoutResultPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <AssistantWidget />
    </div>
  );
}

export default App;
